import {
} from '@angular/core';
import {animate, keyframes, query, sequence, stagger, state, style, transition, trigger} from "@angular/animations";

export const basicTransition: Array<any> = [
    trigger(
        'inOutAnimation',
        [
            transition(
                ':enter',
                [
                    style({height: 0, opacity: 0}),
                    animate('1s ease-out',
                        style({height: 300, opacity: 1}))
                ]
            ),
            transition(
                ':leave',
                [
                    style({height: 300, opacity: 1}),
                    animate('1s ease-in',
                        style({height: 0, opacity: 0}))
                ]
            )
        ]
    )
];

export const fadeTransition: Array<any> = [
    trigger(
        'fadeInOutAnimation',
        [
            transition(
                ':enter',
                [
                    style({opacity: 0}),
                    animate('1s ease-out',
                        style({opacity: 1}))
                ]
            ),
            transition(
                ':leave',
                [
                    style({opacity: 1}),
                    animate('700ms ease-in',
                        style({opacity: 0}))
                ]
            )
        ]
    )
];

export const staggerTransitionInOut: Array<any> = [
    // Trigger animation
    trigger('staggerAnimation', [
        // Transition from any state to any state
        transition('* => *', [
            // Initially the all ele are not visible
            query(':enter', style({ opacity: 0 }), { optional: true }),

            // appear sequentially with the delay of 400ms
            query(':enter', stagger('200ms', [
                animate('1s ease-in', keyframes([
                    style({ opacity: 0, transform: 'translateY(50px)', offset: 0 }),
                    style({ opacity: .5, transform: 'translateY(10px)', offset: 0.1}),
                    style({ opacity: 1, transform: 'translateY(0)', offset: 1 }),
                ]))
            ]), { optional: true }),

            // disappear sequentially with the delay of 500ms
            query(':leave', stagger('100ms', [
                animate('1s ease-out', keyframes([
                style({ opacity: 1, offset: 0 }),
                style({ opacity: 0, offset: 1 }),
                ]))
            ]), { optional: true })
        ]),
    ])
];

export const staggerTransitionIn: Array<any> = [
    // Trigger animation
    trigger('staggerAnimation', [
        // Transition from any state to any state
        transition(":enter", [
            // Initially the all ele are not visible
            query(':enter', style({ opacity: 0 }), { optional: true }),
            // appear sequentially with the delay of 400ms
            query(':enter', stagger('200ms', [
                animate('1.5s ease-in', keyframes([
                    style({ opacity: 0, transform: 'translateY(50px)', offset: 0 }),
                    style({ opacity: .5, transform: 'translateY(10px)', offset: 0.1}),
                    style({ opacity: 1, transform: 'translateY(0)', offset: 1 }),
                ]))
            ]), { optional: true }),
        ])
    ])
];

export const fadePropsTransition: Array<any> = [
    trigger('fadeProperty', [
        state('void, hidden', style({ opacity: 0 })),
        state('visible', style({ opacity: 1 })),
        transition('* => visible', animate('1500ms cubic-bezier(0.0, 0.0, 0.2, 1)')),
        transition('* => hidden', animate('77ms cubic-bezier(0.4, 0.0, 1, 1)')),
    ])
];


export const rowsAnimation: Array<any> = [
    trigger('rowsAnimation', [
        // transition('void => *', [
        //     style({ height: '*', opacity: '0', transform: 'translateX(550px)', 'box-shadow': 'none' }),
        //     sequence([
        //         animate(".35s ease", style({ height: '*', opacity: '.2', transform: 'translateX(0)', 'box-shadow': 'none' })),
        //         animate(".35s ease", style({ height: '*', opacity: 1, transform: 'translateX(0)' }))
        //     ])
        // ])
        state('void', style({ background: 'pink', borderBottomColor: 'pink', opacity: 0, transform: 'translateX(-550px)', 'box-shadow': 'none' })),
        transition('void => *', sequence([
            animate(".5s ease")
        ])),
        transition('* => void', [animate("5s ease")])
    ])
];
